/* Brand splash: self-hosted lottie_svg.min.js or MP4, fetch JSON for Lottie.
   Live: plays once, dismisses. Editor (with preview on): plays once, pins dimmed
   so size/color tweaks remain visible.

   Strategy depends on every preloader knob living in settings_schema.json
   (theme-level). Theme settings trigger a full iframe reload in the editor,
   which re-runs this script. If a preloader knob is ever moved into a
   section schema, add a shopify:section:load listener that calls
   startBrandPreloader() — section re-renders do NOT reload the iframe.

   Skip decisions (design-mode, reduced-motion, session/ever frequency) are
   computed once by the inline gate in brand-preloader.liquid and surfaced
   via data-bp-skip on the overlay. Do not re-check them here. */
(function () {
  'use strict';

  var stageState = new WeakMap();

  function cleanup() {
    try {
      document.documentElement.classList.remove('preloader-active', 'brand-preloader-on');
    } catch (e) {}
  }

  function removeOverlayNode(overlay) {
    if (!overlay || !overlay.parentNode) return;
    try { overlay.parentNode.removeChild(overlay); } catch (e) {}
  }

  function readConfig() {
    var el = document.getElementById('brand-preloader-json');
    if (!el || !el.textContent) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function teardownStage(stage) {
    if (!stage) return;
    var state = stageState.get(stage);
    if (state && typeof state.teardown === 'function') {
      try { state.teardown(); } catch (e) {}
    }
    stageState.delete(stage);
  }

  function startBrandPreloader() {
    var cfg = readConfig();
    if (!cfg || !cfg.enabled) { cleanup(); return; }

    var overlay = document.getElementById('brand-preloader');
    var stage = overlay && overlay.querySelector('[data-preloader-stage]');
    if (!overlay || !stage) { cleanup(); return; }

    if (overlay.dataset.bpSkip === '1') return;

    var inEditorPreview = !!(window.Shopify && window.Shopify.designMode) && !!cfg.editorPreview;

    if (stage.childNodes.length > 0) return;
    if (overlay.dataset.bpStarting === '1') return;
    overlay.dataset.bpStarting = '1';

    try {
      document.documentElement.classList.add('preloader-active', 'brand-preloader-on');
    } catch (e) {}

    var done = false;
    var maxMs = Math.max(1500, cfg.maxMs || 5500);
    var killTimer = setTimeout(function () { dismiss(); }, maxMs);

    function bindLottieResize(anim) {
      teardownStage(stage);
      var resizeTimer = null;
      var debounced = function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          try { if (anim && typeof anim.resize === 'function') anim.resize(); } catch (e) {}
        }, 80);
      };
      debounced();
      var ro = null;
      if (typeof ResizeObserver !== 'undefined') {
        ro = new ResizeObserver(debounced);
        ro.observe(stage);
      }
      window.addEventListener('resize', debounced);
      stageState.set(stage, {
        teardown: function () {
          clearTimeout(resizeTimer);
          try { if (ro) ro.disconnect(); } catch (e) {}
          window.removeEventListener('resize', debounced);
          // Stop lottie-web's internal RAF loop; otherwise the animation keeps
          // ticking on a detached node until GC.
          try { if (anim && typeof anim.destroy === 'function') anim.destroy(); } catch (e) {}
        }
      });
    }

    function finishHidden() {
      if (done) return;
      done = true;
      if (overlay) delete overlay.dataset.bpStarting;
      removeOverlayNode(overlay);
      overlay = null;
      cleanup();
    }

    function pinForEditor() {
      if (done) return;
      clearTimeout(killTimer);
      try { document.documentElement.classList.remove('preloader-active'); } catch (e) {}
      try {
        var v = stage.querySelector('video');
        if (v) v.pause();
      } catch (e) {}
      overlay.classList.remove('is-hiding');
      overlay.classList.add('bp-editor-pinned');
      delete overlay.dataset.bpStarting;
      try { overlay.inert = true; } catch (e) {}
      overlay.setAttribute('aria-hidden', 'true');
    }

    function dismiss() {
      if (done) return;
      clearTimeout(killTimer);
      teardownStage(stage);
      if (!overlay) { cleanup(); return; }
      overlay.classList.remove('bp-editor-pinned');
      overlay.classList.add('is-hiding');
      overlay.addEventListener('transitionend', finishHidden, { once: true });
      setTimeout(finishHidden, 320);
    }

    function onComplete() {
      if (inEditorPreview) pinForEditor();
      else dismiss();
    }

    function markShown() {
      if (cfg.frequency === 'always') return;
      if (inEditorPreview) return;
      try {
        if (cfg.frequency === 'session') sessionStorage.setItem('brandPreloader.shown', '1');
        else if (cfg.frequency === 'ever') localStorage.setItem('brandPreloader.shown', '1');
      } catch (e) {}
    }

    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        if (!src) { reject(new Error('Missing script URL')); return; }
        var s = document.createElement('script');
        s.src = src; s.async = true;
        s.onload = function () { resolve(); };
        s.onerror = function () { reject(new Error('Script load failed: ' + src)); };
        document.head.appendChild(s);
      });
    }

    function startVideo() {
      var urls = cfg.videoSrc || {};
      var url = (cfg.animation === 'fast' && urls.fast) || urls.original || urls.fast;
      if (!url) { console.warn('[brand-preloader] No video URL'); dismiss(); return; }

      var video = document.createElement('video');
      video.className = 'bp-video';
      video.muted = true; video.defaultMuted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'auto');
      video.src = url;
      stage.appendChild(video);

      video.addEventListener('playing', markShown, { once: true });

      if (cfg.hideTrigger === 'load') {
        var animDone = false;
        var loadDone = document.readyState === 'complete';
        var maybeEnd = function () { if (animDone && loadDone) onComplete(); };
        video.addEventListener('ended', function () { animDone = true; maybeEnd(); });
        if (!loadDone) {
          window.addEventListener('load', function () { loadDone = true; maybeEnd(); }, { once: true });
        } else {
          maybeEnd();
        }
      } else {
        video.addEventListener('ended', onComplete);
      }

      video.addEventListener('error', function () {
        console.warn('[brand-preloader] Video error');
        dismiss();
      });

      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function (err) {
          console.warn('[brand-preloader]', err);
          dismiss();
        });
      }
    }

    function startLottie() {
      loadScript(cfg.lottieScript)
        .then(function () {
          if (!window.lottie || typeof window.lottie.loadAnimation !== 'function') {
            throw new Error('lottie global missing after script load');
          }
          var src = (cfg.src && cfg.src[cfg.animation]) || (cfg.src && cfg.src.original);
          if (!src) throw new Error('No animation src configured.');
          return fetch(src, { credentials: 'omit' }).then(function (r) {
            if (!r.ok) throw new Error('Lottie JSON fetch failed: ' + r.status);
            return r.json();
          });
        })
        .then(function (animationData) {
          if (done) return;
          var initialSegment = cfg.animation === 'fast' ? [0, 50] : [0, 82];
          var anim = window.lottie.loadAnimation({
            container: stage,
            renderer: 'svg',
            loop: false,
            autoplay: true,
            animationData: animationData,
            initialSegment: initialSegment,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid meet',
              progressiveLoad: false,
              hideOnTransparent: true,
            },
          });

          bindLottieResize(anim);
          markShown();

          if (cfg.hideTrigger === 'load') {
            var animDone = false;
            var loadDone = document.readyState === 'complete';
            var maybeEnd = function () { if (animDone && loadDone) onComplete(); };
            anim.addEventListener('complete', function () { animDone = true; maybeEnd(); });
            if (!loadDone) {
              window.addEventListener('load', function () { loadDone = true; maybeEnd(); }, { once: true });
            } else {
              maybeEnd();
            }
          } else {
            anim.addEventListener('complete', onComplete);
          }

          anim.addEventListener('data_failed', function () { dismiss(); });
        })
        .catch(function (err) {
          console.warn('[brand-preloader]', err);
          dismiss();
        });
    }

    if (cfg.player === 'video') startVideo();
    else startLottie();
  }

  startBrandPreloader();
})();
